import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import ContentsModal from 'contents_modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class DraftContentsHistory extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * モーダル管理
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    let contents = this.props.contents;
    let table = this.props.table +'_history';
    
    let contents_id = (contents.contents_id == undefined) ? contents.id : contents.contents_id;
    
    // 該当の投稿の過去の修正指示のみ取得
    let parent_media_id = contents.parent_media_id;
    if( parent_media_id != undefined && parent_media_id == null ) parent_media_id = 0;
    
    let history = [];
    try {
      detail[table][contents_id].map((d) => {
        if( d.draft_id >= contents.draft_id ) return;
        //if( d.is_approval != 0 ) return;
        
        if( parent_media_id != undefined ){
          if( parent_media_id === d.id ){
            history.push(d);
            parent_media_id = d.parent_media_id;
            if( parent_media_id !== undefined && parent_media_id == null ) parent_media_id = 0;
          }
        } else {
          history.push(d);
        }
      });
    } catch(e) {}
    
    return (
      <div className="draft-contents-history">
        { (history.length == 0)
          ? <i className="material-icons off">history</i>
          : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>過去の修正指示を見る</Tooltip>}>
              <i className="material-icons on" onClick={this.toggleModal.bind(this, true)}>history</i>
            </OverlayTrigger>
        }
        <HistoryModal view={this.state.modal} detail={detail} history={history} close_ev={this.toggleModal.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class HistoryModal extends React.Component {
  render() {
    if( this.props.view == false ) return null;
    
    let detail = this.props.detail;
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {800}
        height    = {500}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="modal-item draft-contents-history-modal">
            { (this.props.history.length == 0)
              ? <div className="revise-message">過去の履歴がありません</div>
              : <ul className="historys">
                  { this.props.history.map((d, key) => {
                    let draftData = detail.draft_lists[d.draft_id];
                    if( draftData == undefined ) draftData = {};
                    
                    // 修正指示
                    let revise_message = null;
                    try { if( d.revise_message != undefined && d.revise_message != null ) revise_message = Sanitize.nl2br(d.revise_message); } catch(e) {}
                    
                    console.log(d.is_approval);
                    
                    return (
                      <li key={key}>
                        <h5 className="revise-date">Ver.{draftData.version} ({Moment(draftData.create_date).format('YYYY年M月D日')})</h5>
                        
                        <div className="revise-box">
                          { (d.media_url == undefined)
                            ? <div className="revise-image-none" />
                            : <div className="revise-image">
                                { (!Utils.isVideo(d.media_url))
                                  ? <div className="thumbnail"><img src={d.media_url} /></div>
                                  : <div className="thumbnail"><video src={d.media_url} /></div>
                                }
                              </div>
                          }
                          { (d.is_approval == 0)
                            ? <div className="revise-message-top">●修正依頼<div className="revise-message" dangerouslySetInnerHTML={{ __html: revise_message }} /></div>
                            : <p className="approval">●内容OK</p>
                          }
                        </div>
                      </li>
                    );
                  })}
                </ul>
            }
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftContentsHistory;